import { arbitrum } from "thirdweb/chains";

export const chain = arbitrum;

export const THIRD_WEB_CLIENT_ID =
  process.env.THIRD_WEB_CLIENT_ID || "11fb2288161d8c2fb74666e399b9ac58";
export const NFT_CONTRACT_ADDRESS =
  process.env.NFT_CONTRACT_ADDRESS ||
  "0x4b96738ceC714AB7F4cA7b4aF4800EedF42E5B3B";
export const OG_NFT_TOKEN_ID = process.env.NFT_TOKEN_ID || "0";
export const LUNAR_NFT_TOKEN_ID = process.env.LUNAR_NFT_TOKEN_ID || "1";
export const STELLAR_NFT_TOKEN_ID = process.env.STELLAR_NFT_TOKEN_ID || "2";
export const NEBULA_NFT_TOKEN_ID = process.env.NEBULA_NFT_TOKEN_ID || "3";

export const CURRENT_NFT_TOKEN_ID = NEBULA_NFT_TOKEN_ID;
